import { getInitialLoadingElement } from './initialLoadingElement';
import PageChunkLoadingPage from './PageChunkLoadingPage';

type InitialLoadingPageProps = {
  pageLoadingClassName?: string;
};

function InitialLoadingPage({ pageLoadingClassName }: InitialLoadingPageProps) {
  // The static loader from index.html stays visible outside the React root during boot.
  if (getInitialLoadingElement()) return null;

  // If the boot loader is already gone, this is a later loading state.
  return <PageChunkLoadingPage className={pageLoadingClassName} />;
}

export default InitialLoadingPage;
